// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c844c9d7","110":"6de0d0f6","212":"a92c5ce4","552":"154c00f4","582":"9d252e83","602":"99b8eced","637":"1de8bb4e","750":"e8ea88b8","804":"01a6292c","810":"b00a6fde","831":"3b7b2c9d","855":"d710f03f","872":"312739b1","947":"1b19f634","949":"3a15d8be"}[chunkId] + ".chunk.js";
};